import React from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../components";

const InvoiceDiscountModal = ({ open, onClose, rowData }) => {
  console.log("rowData", rowData);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      name: "",
      selectDiscount: "",
      discount: "",
    },
    {
      name: {
        type: "text",
        required: true,
      },
    }
  );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form saved successfully:", formData);

      onClose();
    } else {
      console.log("errros : ", errors);
    }
  };
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      //   title="InvoiceDis countModal"
      width="max-w-7xl"
      showCloseButton={false}
    >
      <div className="">
        <div className="flex justify-between">
          <p>ADD DISCOUNT </p>
          <div>
            INVOICE:{" "}
            <span className="text-primary">{rowData?.invoiceNumber} </span>{" "}
          </div>
        </div>
        <Divider />
        <div className="mt-6">
          <p>
            If you apply discounts here, then the respective invoice amount and
            status will be changed accordingly.
          </p>
        </div>
        <div className="grid grid-cols-3 gap-x-6 gap-y-8 mt-6 max-w-5xl">
          <FormFieldSet
            type="text"
            title={""}
            placeholder="Name"
            value={formData.name}
            onChange={(value) => handleChange("name", value)}
            error={errors.name}
          />
          <FormFieldSet
            type="select"
            title={""}
            placeholder="Select"
            value={formData.selectDiscount}
            onChange={(value) => handleChange("selectDiscount", value)}
            error={errors.selectDiscount}
          />
          <div className="flex gap-3">
            <div className="w-[85%]">
              <FormFieldSet
                type="select"
                title={""}
                placeholder="Discount"
                value={formData.discount}
                onChange={(value) => handleChange("discount", value)}
                error={errors.discount}
              />
            </div>

          <div className="flex gap-3 mt-7 w-[15%]">
              <Button
                type="icon"
                icon="add"
                size="xs"
                color="black"
                // onClick={handleAddDiscount}
              />
              <Button
                type="icon"
                icon="remove"
                size="xs"
                color="danger"
                // onClick={() => handleRemoveDiscount(discount.id)}
              />
            </div>
          </div>
        </div>
        <div className="my-6 flex items-end justify-end">
          <div className="justify-end">
            Subtotal{" "}
            <span className="ml-3">
              {/* {rowData?.invoiceAmount} */}
              17333.16 USD
            </span>
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <Button title={"Cancel"} variant="outlined" onClick={onClose} />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default InvoiceDiscountModal;
